var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        id: "agencyShareBillDialog",
        visible: _vm.innerVisible,
        title: this.$t("SeaExport.AgentIntoBills"),
        width: "1000px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showForm,
              expression: "showForm"
            }
          ],
          staticStyle: { display: "flex", "flex-direction": "row" }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "flex-grow": "1",
                display: "flex",
                "flex-direction": "column"
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.MainOffice") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "250px" },
                          attrs: {
                            placeholder: _vm.$t("Message.PleaseSelect"),
                            clearable: false,
                            size: "mini",
                            disabled: _vm.currentState === "normal"
                          },
                          model: {
                            value: _vm.billing.titleBranchId,
                            callback: function($$v) {
                              _vm.$set(_vm.billing, "titleBranchId", $$v)
                            },
                            expression: "billing.titleBranchId"
                          }
                        },
                        _vm._l(_vm.officeList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.chineseName,
                              value: item.officeId
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.BillNo") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.billing.billingNo,
                          callback: function($$v) {
                            _vm.$set(_vm.billing, "billingNo", $$v)
                          },
                          expression: "billing.billingNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.BillType") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.billingArDesc,
                          callback: function($$v) {
                            _vm.billingArDesc = $$v
                          },
                          expression: "billingArDesc"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    padding: "2px 0"
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { width: "65px", "margin-right": "5px" } },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("Billing.billingJob_originalCurrency"))
                        )
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticStyle: { width: "120px", "margin-right": "5px" } },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("Billing.billingJob_amountOfMoney"))
                        )
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticStyle: { width: "120px", "margin-right": "5px" } },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("Billing.billing_exchangeRate")))
                      ])
                    ]
                  ),
                  _c("div", { staticStyle: { width: "95px" } }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("Billing.billingJob_billAndCurrency"))
                      )
                    ])
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    padding: "2px 0"
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "65px", "margin-right": "5px" },
                    attrs: { disabled: true },
                    model: {
                      value: _vm.billing.sourceCurrency1,
                      callback: function($$v) {
                        _vm.$set(_vm.billing, "sourceCurrency1", $$v)
                      },
                      expression: "billing.sourceCurrency1"
                    }
                  }),
                  _c("el-input-number", {
                    staticStyle: { width: "120px", "margin-right": "5px" },
                    attrs: {
                      min: -999999999999,
                      max: 999999999999,
                      precision: 2,
                      disabled: true,
                      "controls-position": "right"
                    },
                    model: {
                      value: _vm.billing.amount1,
                      callback: function($$v) {
                        _vm.$set(_vm.billing, "amount1", $$v)
                      },
                      expression: "billing.amount1"
                    }
                  }),
                  _c("num-input", {
                    staticStyle: { width: "120px", "margin-right": "5px" },
                    attrs: {
                      min: 0,
                      max: 999999999999,
                      precision: 8,
                      "truncated-precision": _vm.sourceRate1Precision,
                      disabled: !_vm.sourceRateEnable.sourceRate1
                    },
                    on: { change: _vm.calculateAmount },
                    model: {
                      value: _vm.billing.sourceRate1,
                      callback: function($$v) {
                        _vm.$set(_vm.billing, "sourceRate1", $$v)
                      },
                      expression: "billing.sourceRate1"
                    }
                  }),
                  _c("cargo-advance-select", {
                    staticStyle: { width: "120px" },
                    attrs: {
                      filterable: "",
                      "select-type": _vm.selectTypeNames.basic_data_Currency,
                      "default-value": _vm.billing.currency,
                      disabled: _vm.currentState === "normal"
                    },
                    on: { parentCallBack: _vm.currencyChangeEvent }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    padding: "2px 0"
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "65px", "margin-right": "5px" },
                    attrs: { disabled: true },
                    model: {
                      value: _vm.billing.sourceCurrency2,
                      callback: function($$v) {
                        _vm.$set(_vm.billing, "sourceCurrency2", $$v)
                      },
                      expression: "billing.sourceCurrency2"
                    }
                  }),
                  _c("el-input-number", {
                    staticStyle: { width: "120px", "margin-right": "5px" },
                    attrs: {
                      min: -999999999999,
                      max: 999999999999,
                      precision: 2,
                      disabled: true,
                      "controls-position": "right"
                    },
                    model: {
                      value: _vm.billing.amount2,
                      callback: function($$v) {
                        _vm.$set(_vm.billing, "amount2", $$v)
                      },
                      expression: "billing.amount2"
                    }
                  }),
                  _c("num-input", {
                    staticStyle: { width: "120px", "margin-right": "5px" },
                    attrs: {
                      min: 0,
                      max: 999999999999,
                      precision: 8,
                      "truncated-precision": _vm.sourceRate2Precision,
                      disabled: !_vm.sourceRateEnable.sourceRate2
                    },
                    on: { change: _vm.calculateAmount },
                    model: {
                      value: _vm.billing.sourceRate2,
                      callback: function($$v) {
                        _vm.$set(_vm.billing, "sourceRate2", $$v)
                      },
                      expression: "billing.sourceRate2"
                    }
                  }),
                  _c(
                    "div",
                    { staticStyle: { width: "95px", "margin-top": "8px" } },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("Billing.billing_billAmount")))
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    padding: "2px 0"
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "65px", "margin-right": "5px" },
                    attrs: { disabled: true },
                    model: {
                      value: _vm.billing.sourceCurrency3,
                      callback: function($$v) {
                        _vm.$set(_vm.billing, "sourceCurrency3", $$v)
                      },
                      expression: "billing.sourceCurrency3"
                    }
                  }),
                  _c("el-input-number", {
                    staticStyle: { width: "120px", "margin-right": "5px" },
                    attrs: {
                      min: -999999999999,
                      max: 999999999999,
                      precision: 2,
                      disabled: true,
                      "controls-position": "right"
                    },
                    model: {
                      value: _vm.billing.amount3,
                      callback: function($$v) {
                        _vm.$set(_vm.billing, "amount3", $$v)
                      },
                      expression: "billing.amount3"
                    }
                  }),
                  _c("num-input", {
                    staticStyle: { width: "120px", "margin-right": "5px" },
                    attrs: {
                      min: 0,
                      max: 999999999999,
                      precision: 8,
                      "truncated-precision": _vm.sourceRate3Precision,
                      disabled: !_vm.sourceRateEnable.sourceRate3
                    },
                    on: { change: _vm.calculateAmount },
                    model: {
                      value: _vm.billing.sourceRate3,
                      callback: function($$v) {
                        _vm.$set(_vm.billing, "sourceRate3", $$v)
                      },
                      expression: "billing.sourceRate3"
                    }
                  }),
                  _c("el-input-number", {
                    staticStyle: { width: "120px" },
                    attrs: {
                      "controls-position": "right",
                      min: -999999999999,
                      max: 999999999999,
                      precision: 2,
                      disabled: true
                    },
                    model: {
                      value: _vm.billing.amount,
                      callback: function($$v) {
                        _vm.$set(_vm.billing, "amount", $$v)
                      },
                      expression: "billing.amount"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    padding: "2px 0"
                  }
                },
                [
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "row",
                          padding: "2px 0"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.CostGenerationMethod")) +
                              "："
                          )
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "row",
                          padding: "2px 0"
                        }
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.generateChargeGroup,
                              callback: function($$v) {
                                _vm.generateChargeGroup = $$v
                              },
                              expression: "generateChargeGroup"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.SettlementInPriginalCurrency"
                                  )
                                )
                              )
                            ]),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.SettlementInBillCurrency")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticStyle: { "margin-left": "20px" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "row",
                          padding: "2px 0"
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.CostRateValue")) + "："
                          )
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "row",
                          padding: "2px 0"
                        }
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.generateDateRate,
                              callback: function($$v) {
                                _vm.generateDateRate = $$v
                              },
                              expression: "generateDateRate"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.ByBillingDate")))
                            ]),
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.ByBusinessDate")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            ],
            1
          ),
          _c("div", { staticStyle: { width: "10px", height: "100%" } }),
          _c(
            "div",
            {
              staticStyle: {
                "flex-grow": "1",
                display: "flex",
                "flex-direction": "column"
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "90px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.AccountObject") }
                    },
                    [
                      _vm.viewSource === "SeaBooking"
                        ? _c("cargo-advance-select", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": {
                                overseaAgent: true,
                                companyLob: "seaExport",
                                active: true
                              },
                              filterable: "",
                              "callback-params": { key: "accountId" },
                              "callback-method-type": "value",
                              "default-value": _vm.billing.accountId || "",
                              disabled: _vm.currentState === "normal"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.billing.accountId = p.value
                              }
                            }
                          })
                        : _c("cargo-advance-select", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              "select-type":
                                _vm.selectTypeNames.static_data_Company,
                              filterable: "",
                              "callback-params": { key: "accountId" },
                              "callback-method-type": "value",
                              "default-value": _vm.billing.accountId || "",
                              disabled: _vm.currentState === "normal",
                              "static-options": _vm.cmpOverseaList
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.billing.accountId = p.value
                              }
                            }
                          })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Creator") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100px" },
                        attrs: { disabled: true },
                        model: {
                          value: _vm.txtInputByText,
                          callback: function($$v) {
                            _vm.txtInputByText = $$v
                          },
                          expression: "txtInputByText"
                        }
                      }),
                      _c("span", [
                        _vm._v(
                          " " + _vm._s(_vm.$t("SeaExport.Percentage")) + " "
                        )
                      ]),
                      _c("el-input", {
                        staticStyle: { width: "60px" },
                        on: { change: _vm.percentageChangeHandler },
                        model: {
                          value: _vm.billing.percentage,
                          callback: function($$v) {
                            _vm.$set(_vm.billing, "percentage", $$v)
                          },
                          expression: "billing.percentage"
                        }
                      }),
                      _c("span", [_vm._v("%")])
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.DateOfCreation") }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "150px" },
                        attrs: { type: "date" },
                        model: {
                          value: _vm.billing.inputDate,
                          callback: function($$v) {
                            _vm.$set(_vm.billing, "inputDate", $$v)
                          },
                          expression: "billing.inputDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Remarks") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "250px" },
                        attrs: {
                          type: "textarea",
                          disabled: _vm.currentState === "normal",
                          rows: 3
                        },
                        model: {
                          value: _vm.billing.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.billing, "remark", $$v)
                          },
                          expression: "billing.remark"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.showChargeFrom.visible
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_GenerateExpenseAmount"
                            )
                          }
                        },
                        [
                          _c("el-input-number", {
                            staticStyle: {
                              width: "120px",
                              "margin-right": "5px"
                            },
                            attrs: {
                              min: -999999999999,
                              max: 999999999999,
                              precision: 3,
                              "controls-position": "right"
                            },
                            model: {
                              value: _vm.showChargeFrom.chargeAmount,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.showChargeFrom,
                                  "chargeAmount",
                                  $$v
                                )
                              },
                              expression: "showChargeFrom.chargeAmount"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showChargeFrom.visible
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_GenerateExpenseMode")
                          }
                        },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_GenerateInReceivables"
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.showChargeFromChange(
                                        "receivables"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.showChargeFrom.receivables,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.showChargeFrom,
                                        "receivables",
                                        $$v
                                      )
                                    },
                                    expression: "showChargeFrom.receivables"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_GenerateInReceivables"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_GenerateInPay"
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.showChargeFromChange("pay")
                                    }
                                  },
                                  model: {
                                    value: _vm.showChargeFrom.pay,
                                    callback: function($$v) {
                                      _vm.$set(_vm.showChargeFrom, "pay", $$v)
                                    },
                                    expression: "showChargeFrom.pay"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_GenerateInPay")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_GenerateAll")
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.showChargeFromChange("all")
                                    }
                                  },
                                  model: {
                                    value: _vm.showChargeFrom.all,
                                    callback: function($$v) {
                                      _vm.$set(_vm.showChargeFrom, "all", $$v)
                                    },
                                    expression: "showChargeFrom.all"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_GenerateAll"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticStyle: { width: "100%", "text-align": "center" },
          on: {
            click: function($event) {
              _vm.showForm = !_vm.showForm
            }
          }
        },
        [
          _c("i", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showForm,
                expression: "showForm"
              }
            ],
            staticClass: "el-icon-d-arrow-left el-icon--right",
            staticStyle: {
              "font-size": "20px",
              "font-weight": "bold",
              transform: "rotate(90deg)"
            }
          }),
          _c("i", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showForm,
                expression: "!showForm"
              }
            ],
            staticClass: "el-icon-d-arrow-right el-icon--right",
            staticStyle: {
              "font-size": "20px",
              "font-weight": "bold",
              transform: "rotate(90deg)"
            }
          })
        ]
      ),
      _c("cargo-ag-grid", {
        style: { width: "100%", height: _vm.showForm ? "300px" : "553px" },
        attrs: {
          "config-module": "130151",
          "grid-options": _vm.gridOptions,
          "grid-params": _vm.gridParams,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.billing.agentCharge
        },
        on: {
          "update:gridParams": function($event) {
            _vm.gridParams = $event
          },
          "update:grid-params": function($event) {
            _vm.gridParams = $event
          },
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _c(
        "div",
        {
          staticStyle: { padding: "10px", "min-height": "40px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "div",
            { staticStyle: { float: "left" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.chargeSchemaClickHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.ChangeSchema")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.addChargeHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.AddBillCharge")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.removeChargeHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.RemoveBillCharge")))]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { float: "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.saveBtnEnabled },
                  on: { click: _vm.submitHandler }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _vm.chargePlanDialog.visible
        ? _c("charge-scheme-batch-dialog", {
            attrs: {
              visible: _vm.chargePlanDialog.visible,
              lob: _vm.chargePlanDialog.lob,
              "is-sea": _vm.chargePlanDialog.isSea,
              "original-condition": _vm.chargePlanDialog.originalCondition,
              "charge-scheme-is-approved":
                _vm.chargePlanDialog.chargeSchemeIsApproved,
              source: _vm.chargePlanDialog.source,
              job: _vm.job,
              location: _vm.location
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.chargePlanDialog, "visible", $event)
              },
              selectedSchemeHandler: _vm.selectedSchemeHandler
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }